import './wrapper.sass';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidV4 from 'uuid/v4';

import VerticalToolbar from 'components/supervision/vertical-toolbar/VerticalToolbar';
import DataContainer from 'components/supervision/data-container/DataContainer';
import Timeline from 'components/supervision/timeline/Timeline';
import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';
import redirect from 'actions/redirect';
import transmit from 'actions/transmit';

class Wrapper extends Component {
  navigate(paramsSource = null) {
    let recorderId = this.props.recorderId;

    if ((
        !this.props.recorderId
          && Number.isInteger(parseInt(this.props.chosenRecorder.id))
        ) ||
        (
          Number.isInteger(parseInt(this.props.chosenRecorder.id))
          && (
            parseInt(this.props.recorderId)
            !== parseInt(this.props.chosenRecorder.id)
          )
        )
    ) {
      recorderId = this.props.chosenRecorder.id;
    }

    let recorderTemplateId = this.props.recorderTemplateId;

    if ((
        !this.props.recorderId
          && this.props.chosenRecorderTemplates[0]
          && Number.isInteger(parseInt(this.props.chosenRecorderTemplates[0].id))
        ) ||
        (
          this.props.chosenRecorderTemplates[0]
          && Number.isInteger(parseInt(this.props.chosenRecorderTemplates[0].id))
          && (
            parseInt(this.props.recorderTemplateId)
            !== parseInt(this.props.chosenRecorderTemplates[0].id)
          )
        )
    ) {
      recorderTemplateId = this.props.chosenRecorderTemplates[0].id;
    }

    if (paramsSource === null) {
      paramsSource = this.props.paramsSource;
    }

    let recorderTemplateIdUrl = '';
    if ((paramsSource === 'template')
      && (recorderTemplateId !== null)
    ) {
      recorderTemplateIdUrl = `/recorder-template-id/${recorderTemplateId}`;
    }

    this.props.redirect(`/supervision/recorder-id/${recorderId}`
      + `/params-sourse/${paramsSource}`
      + recorderTemplateIdUrl,
      true
    );
  }

  componentWillMount() {
    this.UID = uuidV4().substring(0, 18).replace(/-/g, '');

    this.navigate();
    this.setContainerParams();
  }

  componentDidUpdate() {
    this.navigate();
    this.setContainerParams();
  }

  changeParamsSource(newSource) {
    this.navigate(newSource);
  }

  setContainerParams() {
    if ((this.props.paramsSource === 'template')
      && (this.props.chosenRecorderTemplates.length > 0)
      && (this.props.chosenRecorderTemplates[0].params.length > 0)
    ) {
      this.props.transmit('CLEAR_SUPERVISION_PARAMS')
        .then(() => {
          this.props.chosenRecorderTemplates[0].params.forEach((param) => {
            this.props.transmit('CHANGE_SUPERVISION_PARAMS_CHECKSTATE', {
              ...param,
              ...{ state: true }
            });
          });
        });
    }
  }

  render() {
    if (!Number.isInteger(parseInt(this.props.recorderId))) {
      return <ContentLoader/>
    }

    return (
      <div className='supervision-wrapper'>
        <div className='row'>
          <Timeline uid={ this.UID } recorderId={ parseInt(this.props.recorderId) }/>
        </div>
        <div className='row'>
          <div className='col-sm-3 col-lg-2'>
            <VerticalToolbar
              uid={ this.UID }
              recorderId={ parseInt(this.props.recorderId) }
              paramsSource={ this.props.paramsSource }
              recorderTemplateId={ this.props.recorderTemplateId }
              changeParamsSource={ this.changeParamsSource.bind(this) }
            />
          </div>
          <div className='col-sm-9 col-lg-10'>
            <DataContainer uid={ this.UID } />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    fdrsFetching: state.recorders.pending,
    chosenRecorder: state.recorders.chosen,
    chosenRecorderTemplates: state.recorderTemplates.chosenItems,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    redirect: bindActionCreators(redirect, dispatch),
    transmit: bindActionCreators(transmit, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
